import { getHighestRole } from '../../../utils/RolesService';

export function setUser(profile) {
    if (!profile || !window.clarity) {
        return;
    }
    window.clarity('set', 'userId', profile?.id);
    window.clarity('set', 'customData', {
        companyName: profile?.company?.name,
        companyType: profile?.company?.company_type,
        role: getHighestRole(profile?.roles || [])
    });
}
